<style lang="scss" scoped>
</style>

<template>
        <vForm :label-width="90" :model="formdata" inline>
            <vFormItem label="承运商" class="width-70per margin-left-30" labelWidth="100" align="right" prop="carrierCode" required>
                <Select v-model="formdata.carrierCode" @on-change="changeCarrierServiceList" filterable clearable>
                    <Option v-for="item in getCarrierAllList" :key="item.value" :value="item.attach.carrierCode" >{{ item.label }}</Option>
                </Select>
            </vFormItem>
            <vFormItem label="承运商服务" class="width-70per margin-left-30" labelWidth="100" align="right">
                <Select v-model="formdata.carrierServiceCode" filterable clearable>
                    <Option v-for="item in carrierServiceList" :key="item.id" :value="item.carrierServiceCode" >{{ item.carrierServiceCode }}</Option>
                </Select>
            </vFormItem>
            <vFormItem :label="this.$tc('',1,{defaultValue:'目的地国家'})" class="width-70per margin-left-30" labelWidth="100" align="right" prop="countryId" required>
                <Select v-model="formdata.countryId">
                    <Option v-for="item in getCountryList" :key="item.attach.id" :value="item.attach.id" >{{ item.label }}</Option>
                </Select>
            </vFormItem>
            <vFormItem :label="this.$tc('',1,{defaultValue:'发货地国家'})" class="width-70per margin-left-30" labelWidth="100" align="right" prop="shipRegionId" required>
                <Select v-model="formdata.shipRegionId">
                    <Option v-for="item in getCountryList" :key="item.attach.id" :value="item.attach.id" >{{ item.label }}</Option>
                </Select>
            </vFormItem>
            <compUpload
                v-bind="getFileProps"
                @on-close="close"
                @on-success="success"
            ></compUpload>
        </vForm>
</template>

<script>
import { HttpCarrierList } from '@/service/account';
import { HttpGetProductServiceByOrg } from "@/service/fedex";
import { mapGetters } from 'vuex';
    export default {
        components: {
            compUpload: () => import("@components/templates/upload")
        },
        data() {
            return {
                carrierCode: '',
                carrierServiceCode: '',
                countryId: '',
                shipRegionId: '',
                formdata: {
                    carrierCode: '',
                    carrierServiceCode: '',
                    countryId: '',
                    shipRegionId: ''
                },
                carrierServiceList: [],
                required: [{
                    required: true,
                    message: this.$t('global.common.required',{defaultValue:'该信息不能为空,请填写'})
                }],
            }
        },
        created(){
            this.getOrgGroupList();
        },
        computed: {
            ...mapGetters('dictionary', ['getOrgList','getCarrierAllList','getCountryList', 'getServiceAllList']),
            getFileProps() {
                return {
                    action: process.env.VUE_APP_APIURL_FBB+'/api/v2/carrierZone/importCarrierZone',
                    name: "multipartFile",
                    data: {
                        carrierCode: this.formdata.carrierCode,
                        carrierServiceCode: this.formdata.carrierServiceCode,
                        countryId:this.formdata.countryId,
                        shipRegionId:this.formdata.shipRegionId
                    },
                    download:()=>{
                        this.handleWebfs("/static/template/account_areamaintian.xlsx", {}, {
                            executor: 'download',
                            type: 'url'
                        });
                        // this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/warehouseStorage/warehouseStorageTemplate", {}, 'download')
                    }
                }
            },
        },
        methods: {
            changeCarrierServiceList(val){
                this.formdata.carrierServiceCode = '';
                if(val){
                    // HttpCarrierList({'search[EQ_carrierCode]': val})
                    let carrierId = this.getCarrierAllList.filter(item=>item.attach.carrieCode == val)[0].value
                    HttpGetProductServiceByOrg({
                        'search[EQ_carrierId]': carrierId,
                        'search[EQ_active]':1,
                    })
                    .then(res=>{
                        this.carrierServiceList = res.data;
                    },err=>{
                        this.$VMessage.error(err.message);
                    })
                }else{
                    this.carrierServiceList = []
                }
            },
            success(res) {
                // console.log(343434343)
                this.$VMessage.success(res.message);
                this.close();
            },
            close() {
                // console.log(5656565656)
                this.$emit('on-close');
            }
        }
    }
</script>
